/**
 * Standalone Get Customers product root (`/get-customers`).
 * Prefer `useCustomersPaths()` for in-app links (embed-aware later).
 */
export const CUSTOMERS_BASE = '/get-customers'

/**
 * Get Customers chrome. On in every non-production deployment.
 * Modelled on the former Advisors `ADVISORS_FEATURES_ENABLED` flag (removed 2026-10-15).
 */
export const CUSTOMERS_FEATURES_ENABLED = process.env.NEXT_PUBLIC_DEPLOYMENT_ENV !== 'production'

/** Wil Tool slug — must match backend `CUSTOMERS_WIL_TOOL_SLUG`. */
export const CUSTOMERS_WIL_TOOL_SLUG = 'customers-wil'
